import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdBlockDetector',
  setup(__props) {

const store = useStore();

let errcnt = 0;

function testImg() {
  const i = new Image();
  i.onerror = () => {
    errcnt += 1;
    if (errcnt < 3) {
      setTimeout(testImg, 250);
    } else {
      store.commit('setAdsBlocked');
    }
  };
  i.onload = () => {
    store.commit('setAdsNotBlocked');
  };

  i.src = 'https://nitropay.com/wp-content/uploads/2022/08/np-white.png';
}
testImg();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})